import type { RenderContext, VideoFrame } from '../../types';
import { WebGLShaderProgram } from '../../gpu/shader';
import { BaseEffect } from '../base';
import { VERTEX_FULLSCREEN, FRAG_DREAM_HAZE } from '../../shaders/glsl';

const DEFAULTS = { amount: 0.45, bloom: 0.7, lift: 0.25 };

let hazeProg: WebGLShaderProgram | null = null;

export class DreamHazeEffect extends BaseEffect {
  constructor(id: string, clip: Partial<import('../../types').EffectTimelineClip>) {
    super(id, 'dream_haze', clip, DEFAULTS);
  }

  protected renderGpu(frame: VideoFrame, params: Record<string, number>, context: RenderContext): VideoFrame {
    const gl = context.gpu!.gl;
    if (!hazeProg) hazeProg = new WebGLShaderProgram(gl, VERTEX_FULLSCREEN, FRAG_DREAM_HAZE);
    return this.runShaderPass(frame, hazeProg, (_gl, prog) => {
      prog.setUniform1i('u_texture', 0);
      prog.setUniform1f('u_amount', params.amount);
      prog.setUniform1f('u_bloom', params.bloom);
      prog.setUniform1f('u_lift', params.lift);
    }, context);
  }

  protected renderCpu(frame: VideoFrame, params: Record<string, number>, _context: RenderContext): VideoFrame {
    const canvas = document.createElement('canvas');
    canvas.width = frame.width;
    canvas.height = frame.height;
    const ctx = canvas.getContext('2d');
    if (!ctx) return frame;
    const src = frame.canvas as CanvasImageSource;
    ctx.drawImage(src, 0, 0);
    ctx.globalCompositeOperation = 'lighter';
    ctx.filter = `blur(${4 + params.bloom * 10}px)`;
    ctx.globalAlpha = params.amount * 0.55;
    ctx.drawImage(src, 0, 0);
    ctx.filter = 'none';
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = 'source-over';
    ctx.fillStyle = `rgba(255,250,240,${params.lift * 0.12})`;
    ctx.fillRect(0, 0, frame.width, frame.height);
    return { width: frame.width, height: frame.height, canvas, texture: null };
  }
}
